// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Lq5E","requiredAsterisk":"Info_requiredAsterisk__34BZP"};